import { CommonModule } from "@angular/common";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Button } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";

@Component({
  selector: "jni-confirm-change",
  templateUrl: "./confirm-change.component.html",
  styleUrls: ["./confirm-change.component.scss"],
  providers: [ConfirmationService],
  imports: [ConfirmDialogModule, CommonModule, Button],
})
export class ConfirmChangeComponent implements OnInit {
  @Output() confirmDialogStatus = new EventEmitter<boolean>();
  constructor(private confirmationService: ConfirmationService) {}

  ngOnInit(): void {
    this.changeAlert();
  }

  confirmationMessage = `
    <p>Updating the <b>Buyer Name</b> will apply this change to the <b>Buyer Name</b> field in the following areas:</br></br></p>
    <ul>
      <li>All sales tasks linked to the project</li>
      <li>All Production tasks linked to the project</li>
      <li>The Project Header</li>
      <li>The order associated with the project</li>
    </ul>
  `;

  changeAlert() {
    this.confirmationService.confirm({
      message: this.confirmationMessage,
      header: "Are you sure?",
      accept: () => {
        this.confirmDialogStatus.emit(true);
      },
      reject: () => {
        this.confirmDialogStatus.emit(false);
      },
    });
  }
}
